import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { forYouItems, notForYouItems } from '../data/forWho';
export function ForWhoSection() {
  return <section aria-label="Who LACROSSE READY 360 is for" className="bg-cream px-5 py-20 md:py-28" data-id="element-89" data-mp="2h66tb8cy65p5">
      <Reveal className="mx-auto grid max-w-content items-start gap-6 md:grid-cols-2" data-id="element-90" data-mp="2c7nb9j1h5e22">
        <article className="overflow-hidden rounded-card bg-white shadow-card" data-id="element-91" data-mp="285s5o2cigeih">
          <h2 className="bg-turquoise px-6 py-4 font-display text-sm font-bold uppercase tracking-[0.12em] text-pine" data-id="element-92" data-mp="283fh36c8z5wg">
            THIS IS FOR YOU IF
          </h2>
          <ul className="divide-y divide-slate-line" data-id="element-93" data-mp="1y8dt4dtpk9vg">
            {forYouItems.map(item => <li key={item} className="flex items-start gap-3 px-6 py-4" data-id="element-94" data-mp="1t9t1h2siuyim">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-turquoise-tint text-turquoise" data-id="element-95" data-mp="3slvim6dobgt4">
                  <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-96" data-mp="3nnbv41jflwyn" />
                </span>
                <span className="text-sm font-medium leading-snug text-ink" data-id="element-97" data-mp="1sc5w3q6yucml">{item}</span>
              </li>)}
          </ul>
        </article>
        <article className="overflow-hidden rounded-card bg-white shadow-card" data-id="element-98" data-mp="1icomwysi9glv">
          <h2 className="bg-[#E9EBEA] px-6 py-4 font-display text-sm font-bold uppercase tracking-[0.12em] text-slate-body" data-id="element-99" data-mp="1naggrycpncsp">
            THIS IS NOT FOR YOU IF
          </h2>
          <ul className="divide-y divide-slate-line" data-id="element-100" data-mp="2b2x1kgnu1ivp">
            {notForYouItems.map(item => <li key={item} className="flex items-start gap-3 px-6 py-4" data-id="element-101" data-mp="2g1i3qlmnacms">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#EEF0EF] text-slate-body" data-id="element-102" data-mp="21ahifg0suo98">
                  <XIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-103" data-mp="2tzoqp6q22s7o" />
                </span>
                <span className="text-sm leading-snug text-slate-body" data-id="element-104" data-mp="2yqon8av9j89n">{item}</span>
              </li>)}
          </ul>
        </article>
      </Reveal>
    </section>;
}